import React, { useEffect, useState } from 'react';
import { Box, Button, Typography, Chip } from '@mui/material';
import PropTypes from 'prop-types';
import { DataGrid } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

function QuickSearchToolbar() {
  return (
    <Box
      className="tableTopWrap page__title"
      sx={{
        borderBottom: '1px solid rgba(0,0,0,0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: 2
      }}
    >
      <Typography sx={{ fontSize: '16px', fontWeight: '700' }}>Recent Invoices </Typography>
      <Button
        variant="text"
        size="small"
        sx={{ p: '0!important', minWidth: 'auto!important' }}
        endIcon={<ChevronRightIcon />}
        component={Link}
        to="/payment-request"
        color="secondary"
      >
        Show All
      </Button>
    </Box>
  );
}

function RecentInvoice({ data }) {
  const [tableData, setTableData] = useState([]);

  const columns = [
    {
      field: 'invoice_number',
      headerName: 'Invoice Number',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      sortable: false
    },
    {
      field: 'name',
      headerName: 'Client',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      sortable: false
    },
    {
      field: 'grand_total',
      headerName: 'Amount',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        if ((params && params.value) || (params.row && params.row.symbol)) {
          return (
            <Typography component="p" variant="body1" sx={{ fontSize: '14px', fontWeight: '700' }}>
              {`${params.row.short_name} ${params.value}`}
            </Typography>
          );
        }
        return null;
      }
    },
    {
      field: 'invoice_date',
      headerName: 'Request Date',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        if (params && params.value) {
          return (
            <Typography component="p" variant="body1" sx={{ fontSize: '14px', fontWeight: '700' }}>
              {params.value}
            </Typography>
          );
        }
        return null;
      }
    },
    {
      field: 'status',
      headerName: 'Status',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        if (params && params.value) {
          return (
            <Chip label={params.value} color={params.value.toLowerCase().replace(/\s+/g, '')} />
          );
        }
        return null;
      }
    }
  ];

  useEffect(() => {
    if (data && data.length > 0) {
      setTableData(data);
    } else {
      setTableData([]);
    }
  }, [data]);

  const tableStyle = {
    bgcolor: 'white',
    '& .super-app-theme--header': {
      backgroundColor: 'primary.main',
      color: '#fff',
      '.MuiDataGrid-columnHeaderTitle': {
        fontWeight: '700',
        fontSize: '14px'
      }
    }
  };

  return (
    <Box sx={tableStyle} className="dashtableWrapper">
      <DataGrid
        disableColumnSorting
        rows={tableData}
        getRowId={(row) => row.unique_id}
        columns={columns}
        disableColumnSelector
        disableVirtualization
        disableColumnMenu
        autoHeight
        disableColumnFilter
        hideFooter
        rowHeight={40}
        columnHeaderHeight={40}
        slots={{
          toolbar: QuickSearchToolbar
        }}
      />
    </Box>
  );
}

RecentInvoice.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      invoice_number: PropTypes.string.isRequired,
      grand_total: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
      short_name: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      invoice_date: PropTypes.string.isRequired
      // Add other properties expected in the object
    })
  ).isRequired
};

export default RecentInvoice;
